export enum ResponseStatusCode {
    UNAUTHORIZED = 401,
    BAD_REQUEST = 400,
    FORBIDDEN = 403,
    EXCEPTION_FAILED=417,
    NOT_FOUND = 404,
}